module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website.f66531d0.webp";